export const queryKeys = {
	user: {
		all: ["user"] as const,
		profile: () => [...queryKeys.user.all, "profile"] as const,
		coins: () => [...queryKeys.user.all, "coins"] as const,
		images: () => [...queryKeys.user.all, "images"] as const,
		friendsAll: () => [...queryKeys.user.all, "friends"] as const,
		friends: (page?: number) => [...queryKeys.user.friendsAll(), { page }] as const,
		friendRequestsAll: () => [...queryKeys.user.all, "friend-requests"] as const,
		friendRequests: (page?: number) => [...queryKeys.user.friendRequestsAll(), { page }] as const,
		friendOffersAll: () => [...queryKeys.user.all, "friend-offers"] as const,
		friendOffers: (page?: number) => [...queryKeys.user.friendOffersAll(), { page }] as const,
		favoritesAll: () => [...queryKeys.user.all, "favorites"] as const,
		favorites: (page?: number) => [...queryKeys.user.favoritesAll(), { page }] as const,
		blockedAll: () => [...queryKeys.user.all, "blocked"] as const,
		blocked: (page?: number) => [...queryKeys.user.blockedAll(), { page }] as const,
	},
	messenger: {
		all: ["messenger"] as const,
		conversations: () => [...queryKeys.messenger.all, "conversations"] as const,
		conversation: (id: string) => [...queryKeys.messenger.all, "conversation", id] as const,
		conversationInfo: (id: string) =>
			[...queryKeys.messenger.all, "conversation-info", id] as const,
		unreadCount: () => [...queryKeys.messenger.all, "unread-count"] as const,
		gifts: () => [...queryKeys.messenger.all, "gifts"] as const,
		prices: () => [...queryKeys.messenger.all, "prices"] as const,
	},
	search: {
		all: ["search"] as const,
		results: (filters: object) => [...queryKeys.search.all, "results", filters] as const,
		random: () => [...queryKeys.search.all, "random"] as const,
	},
	profile: {
		all: ["profile"] as const,
		byName: (name: string) => [...queryKeys.profile.all, name] as const,
		info: (name: string) => [...queryKeys.profile.all, name, "info"] as const,
		location: (id: number) => [...queryKeys.profile.all, id, "location"] as const,
	},
	register: {
		all: ["register"] as const,
		validateUsername: (name: string) => [...queryKeys.register.all, "username", name] as const,
		validateEmail: (email: string) => [...queryKeys.register.all, "email", email] as const,
		places: (query: string) => [...queryKeys.register.all, "places", query] as const,
	},
	config: {
		all: ["config"] as const,
		public: () => [...queryKeys.config.all, "public"] as const,
	},
	payment: {
		all: ["payment"] as const,
		methods: () => [...queryKeys.payment.all, "methods"] as const,
	},
	news: {
		all: ["news"] as const,
	},
	faq: {
		all: ["faq"] as const,
		items: () => [...queryKeys.faq.all, "items"] as const,
		tickets: () => [...queryKeys.faq.all, "tickets"] as const,
		ticket: (id: number) => [...queryKeys.faq.all, "ticket", id] as const,
	},
	attributes: {
		all: ["attributes"] as const,
		definitions: () => [...queryKeys.attributes.all, "definitions"] as const,
	},
} as const;
